import { render, staticRenderFns } from "./RiskBar.vue?vue&type=template&id=3bb11fb1&"
import script from "./RiskBar.vue?vue&type=script&lang=js&"
export * from "./RiskBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports